<template>
  <b-card title="ویدیو">
    <b-card-text>
      <span>در این قسمت می توانید به گالری خود ویدیو اضافه کنید </span>
    </b-card-text>


    <b-row>
      <b-col cols="12">
        <b-form-group
            label="آپلود ویدیو"

        >
          <b-form-file
              placeholder="فایل خود را انتخاب کنید یا اینجا drop کنید"
              drop-placeholder="Drop file here..."
              accept=".mp4,.mkv"
              @change="handleLoadVideo($event)"
          />

        </b-form-group>
      </b-col>

      <b-col cols="6">
          <video class="video-preview" id="video-preview" controls :src="videoUrl"/>
      </b-col>
    </b-row>







  </b-card>
</template>

<script>
import {BFormTextarea, BCardText,BRow,BCol, BFormFile,BCard, BFormGroup, BFormInput, BButton} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import UploadFile from '@/modules/components/upload/uploadFile'
import uploadService from "@/modules/services/uploadService";


export default {
  name: "videoFormComponent",
  props:['videoUrl'],
  components: {
    BCard,
    BButton,
    BFormInput,
    BFormGroup,
    BFormTextarea,
    BCardText,
    UploadFile,
    BFormFile,
    BRow,
    BCol

  },
  data() {
    return {
      videoFile:'',
      // videoUrl:'',
      data: {
        name: '',
        videoAddress: '',
        link:''
      },
    }
  },
  created() {
  },
  methods: {
    handleLoadVideo($event){
      this.videoFile = $event.target.files[0]
      this.$emit('videoChanged', this.videoFile);

      this.previewVideo();
    },
    previewVideo(){
      let video = document.getElementById('video-preview');
      let reader = new FileReader();

      reader.readAsDataURL( this.videoFile );
      reader.addEventListener('load', function(){
        video.src = reader.result;
      });
    },
  }
  ,
  directives: {
    Ripple,
  },

}
</script>

<style scoped>
.ck-editor__editable  {
  height: 400px !important;
}

.video-preview{
  max-width: 500px;
  max-height: 350px;
}
</style>
